import type { Slide } from '@ai-platform/database';

import { MetrikaGoal, useMetrika } from '../../../hooks';

export const useSlideMetrika = (slideId: Slide['id']) => {
    const { reachGoal } = useMetrika();

    const reachSlideGoal = () => {
        reachGoal(MetrikaGoal.ClickSlide);
        // Отправляем дополнительную цель с идентификатором слайда если захотим посмотреть CTR
        reachGoal(`${MetrikaGoal.ClickSlide}_${slideId}` as MetrikaGoal);
    };

    return reachSlideGoal;
};
